import script from "./StatisticSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticSection.vue?vue&type=script&setup=true&lang=js"

import "./StatisticSection.vue?vue&type=style&index=0&id=93a344a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93a344a4"]])

export default __exports__